/* istanbul ignore file */
export enum PinSize {
    minPinSize = 10,
    maxPinSize = 50,
    defaultPinSize = 35
}
